<template>
  <div class="leftmenu">
    <div class="morelist">
      <div class="text" v-for="(nav, i) in list" :key="i" @click="navpath(nav, i)" style="cursor: pointer;">
        <div class="titles" :class="{ navactive: isNavActive(nav), towmenu: !nav.path }">
          <div class="left-title" style="display: flex;margin-left:5px;">
			  <strong class="left-title-img" :class="{ 'left-title-img_active': isNavActive(nav)}" v-if="isValidMenuIcon(nav.meta.icon)">
				   <img   :src="nav.meta.icon" @error="onMenuIconError" style=" width:20px;height: 20px;margin-right: 4px;" alt="" srcset="" />
			  </strong>
			 
            <!-- <svg-icon v-if="nav.meta.icon" :class="{ 'hi-svg': nav.path == $route.path }" :icon-class="nav.meta.icon"
              style="margin-right: 4px;font-size: 18px;color:#999;position: relative;top: 3px;"></svg-icon> -->
            <span v-else style="display: inline-block; width: 1em;height: 1em;position: relative;top: 3px;"></span>
            <span>{{ nav.meta.title }}</span> 
          </div>
          <span class="icons" :class="{ transition90: childindex == i || nav.isShow }"
            v-if="nav.children && nav.children.length > 0">
            <i class="el-icon-arrow-right"></i>
          </span>
          <div class="activeBack">{{ nav.meta.title }}</div>
        </div>

        <el-collapse-transition>
          <div class="flex-list" v-show="childindex == i || nav.isShow">
            <div v-for="(children, children_i) in nav.children" :key="children_i" style="width: 100%;">
              <div class="childtext" :class="{ navactive: isNavActive(children) }" v-if="children.meta.layout == 1"
                :key="children_i" @click.stop="threepath(children)" style="cursor: pointer;">
                <span>{{ children.meta.title }}</span>
                <div class="activeBack">{{ children.meta.title }}</div>
              </div>
            </div>
          </div>
        </el-collapse-transition>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      meun: [],
      list: [],
      childindex: 0,
      userinfo: "",
      loading: true,
      isShow: true,
    };
  },
  created() {
    let routes = JSON.parse(sessionStorage.getItem("routestext")) || [];
    let staticRoutes = this.$router.options.routes || [];
    
    // 从动态路由中获取菜单
    routes.forEach((item) => {
      if (item.meta && item.meta.layout == 1) {
        this.meun.push(item);
      }
    });
    
    // 如果动态路由中没有菜单，从静态路由中获取
    if (this.meun.length === 0) {
      staticRoutes.forEach((item) => {
        if (item.meta && item.meta.layout == 1) {
          this.meun.push(item);
        }
      });
    }
    
    this.children_route();
  },
  mounted() {
    this.getInfo();
  },
  watch: {
    $route: function (newflag, oldflag) {
      this.children_route();
    },
  },
  methods: {
    //获取信息
    getInfo() {
      let info = JSON.parse(sessionStorage.getItem("userinfo"));
      if (info && info.roles && info.roles.length > 0) {
        let guard_name = "";
        if (info.roles[0].id == 59) {
          guard_name = "api";
        }
        if (info.roles[0].id == 22) {
          guard_name = "store_admin_user";
        }
        if (!guard_name) {
          return;
        }
      }
    },
    // 菜单图标加载失败时（如后端返回的 icon 路径已失效），用默认灰色方块兜底，避免控制台 404 报错
    onMenuIconError(e) {
      const target = e && e.target ? e.target : e;
      if (!target) return;
      // 防止 onerror 循环
      target.onerror = null;
      // 一个简单的灰色方块 SVG（base64 编码，20x20）
      const defaultIcon =
        "data:image/svg+xml;base64," +
        "PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDIwIDIwIj48cmVjdCB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHg9IjIiIHk9IjIiIGZpbGw9IiNjY2MiIHN0cm9rZT0iIzk5OSIgc3Ryb2tlLXdpZHRoPSIxIi8+PC9zdmc+";
      target.src = defaultIcon;
    },
    // 判断菜单 icon 路径是否是"已知坏路径"（后端配了已失效的旧存储地址）
    // 坏路径的 icon 不渲染 <img>，避免触发 404 网络请求，视觉效果和"未配 icon"一致
    isValidMenuIcon(icon) {
      if (!icon) return false;
      // 已知坏路径模式（持续补充）
      const badPatterns = [
        "comsol/storage/", // shop 版老存储路径（已失效）
        "/wxh/",            // wxh 子目录下的旧图标
        "storage/wxh/",     // 兼容写法
      ];
      return !badPatterns.some((pattern) => icon.includes(pattern));
    },
    isNavActive(nav) {
      if (!nav.path) return false;
      const currentPath = this.$route.fullPath;
      // 路径（不含 query）维度匹配，避免 menu.path 与 route.fullPath 因携带 query 参数不匹配
      const currentPathNoQuery = currentPath.split('?')[0];
      
      // 精确匹配：fullPath 或 path 都尝试
      if (nav.path === currentPath || nav.path === currentPathNoQuery) return true;
      
      // 带参数的路由匹配（如 /application/competition/contestant/:id）
      if (nav.path.includes(':') && (currentPath.startsWith(nav.path.split(':')[0]) || currentPathNoQuery.startsWith(nav.path.split(':')[0]))) {
        return true;
      }
      
      // 选手列表页面 - 只选中选手列表菜单
      if (currentPath.startsWith('/weishop/application/sign/list')) {
        if (nav.meta && nav.meta.title === '选手列表') {
          return true;
        }
        // 其他菜单都不选中
        return false;
      }
      
      // 投票记录页面 - 只选中投票记录菜单
      if (currentPath.startsWith('/weishop/application/voteLog/list')) {
        if (nav.meta && nav.meta.title === '投票记录') {
          return true;
        }
        // 其他菜单都不选中
        return false;
      }
      
      // 前缀匹配：子路由应该激活父菜单（同时去掉 query 比较）
      if (currentPath.startsWith(nav.path + '/') || currentPathNoQuery.startsWith(nav.path + '/')) {
        return true;
      }
      
      return false;
    },
    calclayout(arr) {
      console.log('%c [ arr ]-102', 'font-size:13px; background:#83f2a2; color:#c7ffe6;', arr)
      let count = 0;
      arr.forEach((item) => {
        if (item.layout == 1) {
          count++;
        }
      });
      if (count > 1) {
        return true;
      } else {
        return false;
      }
    },
    //监控子路由
    children_route() {
      let that = this;
      let routes = JSON.parse(sessionStorage.getItem("routestext")) || [];
      // 获取静态路由
      let staticRoutes = this.$router.options.routes || [];
      
      // 检查当前路由是否设置了showMenu: false
      if (this.$route.meta && this.$route.meta.showMenu === false) {
        that.list = [];
        this.$store.commit("changeasideWidth", 0);
        return;
      }
      
      // 查找当前路由所属的父路由路径前缀
      let currentPath = this.$route.path;
      let parentPath = currentPath.substring(0, currentPath.lastIndexOf('/'));
      
      // 选手管理和投票记录特殊处理：使用活动列表的路径前缀
      if (currentPath.startsWith('/weishop/application/sign/list') || 
          currentPath.startsWith('/weishop/application/voteLog/list')) {
        parentPath = '/application/competition';
      }
      
      if (parentPath === '/application') {
        parentPath = '/application/competition';
      }
      
      // 分红池页面兜底：直接用静态路由构建左侧菜单（F5 时动态路由可能还没匹配到）
      if (currentPath.startsWith('/weishop/application/poolprofit/')) {
        that.list = [];
        staticRoutes.forEach((item) => {
          if (item.path && item.path.startsWith('/weishop/application/poolprofit/') && item.meta && item.meta.title) {
            let exists = that.list.some(route => route.path === item.path);
            if (!exists) {
              that.list.push(item);
            }
          }
        });
        const orderMap = {
          '/weishop/application/poolprofit/set': 1,
          '/weishop/application/poolprofit/good/index': 2,
          '/weishop/application/poolprofit/withdraw': 3,
          '/weishop/application/poolprofit/order': 4,
          '/weishop/application/poolprofit/keeper': 5,
          '/weishop/application/poolprofit/partner': 6,
          '/weishop/application/poolprofit/balance/index': 7,
        };
        that.list.sort((a, b) => (orderMap[a.path] || 99) - (orderMap[b.path] || 99));
        this.$store.commit("changeasideWidth", that.list.length > 0 ? 50 : 0);
        return;
      }
      
      // 获取当前路由的meta.title（添加空值检查）
      let currentMetaTitle = '';
      if (that.$route.matched && that.$route.matched.length > 0 && that.$route.matched[0].meta && that.$route.matched[0].meta.title) {
        currentMetaTitle = that.$route.matched[0].meta.title;
      }
      
      // 选手管理和投票记录页面，使用活动列表的标题进行匹配
      if (currentPath.startsWith('/weishop/application/sign/list') || 
          currentPath.startsWith('/weishop/application/voteLog/list')) {
        currentMetaTitle = '投票活动';
      }
      
      // 先从动态路由中查找
      let found = false;
      routes.forEach((item) => {
        if (item.meta && item.meta.title == currentMetaTitle) {
          found = true;
          that.list = [];
          if (item.children && item.children.length) {
            item.children.forEach((child) => {
              // 过滤掉组件路径包含错误路径名的路由
              if (child.meta && child.meta.layout == 1) {
                let isValid = true;
                if (child.component && typeof child.component === 'string') {
                  isValid = !child.component.includes('singGift');
                }
                if (isValid) {
                  that.list.push(child);
                }
              }
            });
          }
          // 如果动态路由中没有找到有效的子菜单，尝试从静态路由中查找
          if (that.list.length === 0) {
            staticRoutes.forEach((route) => {
              if (route.meta && route.path && route.path.startsWith(parentPath) && route.meta.layout == 1) {
                that.list.push(route);
              }
            });
          }
        }
      });
      
      // 如果动态路由中没找到，从静态路由中查找同路径前缀的路由
      if (!found || that.list.length === 0) {
        staticRoutes.forEach((item) => {
          if (item.meta && item.path && item.path.startsWith(parentPath) && item.meta.layout == 1) {
            // 检查是否已经存在于list中
            let exists = that.list.some(route => route.path === item.path);
            if (!exists) {
              that.list.push(item);
            }
          }
        });
      }
      
      if (that.list.length > 0) {
        this.$store.commit("changeasideWidth", 50);
      } else {
        this.$store.commit("changeasideWidth", 0);
      }
    },
    //跳转
    meunlink(item, index) {
      if (item.path) {
        if (item.path != this.$route.path) {
          let userinfo = JSON.parse(sessionStorage.getItem("userinfo")) || "";
          let unitid = userinfo.unitid || "";

          if (item.path == "/applist") {
            let routes = JSON.parse(sessionStorage.getItem("routes"));
            routes.some((item, index) => {
              if (item.path == "/applist" && item.component == "Layout") {
                item._child = [];
                item.component = "applist/applist.vue";
                resetRouter();
                router.addRoutes(changeroute(routes));
                sessionStorage.setItem("routes", JSON.stringify(routes));
              }
            });
          }

          if (item.path == "/voteapps") {
            let routes = JSON.parse(sessionStorage.getItem("routes"));
            routes.some((item, index) => {
              if (item.path == "/voteapps" && item.component == "Layout") {
                item._child = [];
                item.component = "apps/vote/apps/apps.vue";
                resetRouter();
                router.addRoutes(changeroute(routes));
                sessionStorage.setItem("routes", JSON.stringify(routes));
              }
            });
          }

          if (item.path == "/channel" && unitid == 3) {
            let routes = JSON.parse(sessionStorage.getItem("routes"));
            routes.some((item, index) => {
              if (item.path == "/channel" && item.component == "Layout") {
                item._child = [];
                item.component = "apps/vote/channel/channel.vue";
                resetRouter();
                router.addRoutes(changeroute(routes));
                sessionStorage.setItem("routes", JSON.stringify(routes));
              }
            });
          }

          //渠道一级菜单 清空动态添加
          if (item.path == "/channel" && unitid != 3) {
            let routes = JSON.parse(sessionStorage.getItem("routes"));
            routes.some((item, index) => {
              if (item.path == "/channel" && item.component == "Layout") {
                item._child = [];
                item.component = "apps/channel/channel.vue";
                resetRouter();
                router.addRoutes(changeroute(routes));
                sessionStorage.setItem("routes", JSON.stringify(routes));
              }
            });
          }
			console.log("itemitem",item)
          //应用一级菜单 清空动态添加
          if (item.path == "/makou/application/index") {
            let routes = JSON.parse(sessionStorage.getItem("routes"));
            routes.some((item, index) => {
              if (item.path == "/makou/application/index" && item.component == "Layout") {
                item.component = "apps/makou/application/index.vue";
                // if(unitid==4){
                // 	item.component = 'apps/shopping/apps/apps.vue'
                // }
                resetRouter();
                router.addRoutes(changeroute(routes));
                sessionStorage.setItem("routes", JSON.stringify(routes));
              }
            });
          }

          this.$router.push({
            path: item.path,
          });
          this.$store.commit("changeasideWidth", 0);
        }
      } else {
        if (item.children[0].path != this.$route.path) {
          for (let i = 0; i < item.children.length; i++) {
            let child = item.children[i];
            if (child.meta.layout == 1) {
              if (child.children) {
                this.childindex = 0;
                if (child.children[0].path == this.$route.path) {
                  return;
                }

                if (child.children[0].meta.props) {
                  this.$router.push({
                    path: child.children[0].path,
                    query: {
                      props: child.children[0].meta.props,
                    },
                  });
                  return;
                } else {
                  this.$router.push({
                    path: child.children[0].path,
                  });
                  return;
                }
              } else {
                this.childindex = -1;
                if (child.meta.props) {
                  this.$router.push({
                    path: child.path,
                    query: {
                      props: child.meta.props,
                    },
                  });
                } else {
                  this.$router.push({
                    path: child.path,
                  });
                }
                this.$store.commit("changeasideWidth", 50);
                return;
              }
            }
          }
          this.$store.commit("changeasideWidth", 0);
        }
      }
    },
    //二级菜单跳转
    navpath(item, index) {
      this.$set(this.list[index], "isShow", false);
      if (item.children) {
        if (this.childindex == index) {
          this.childindex = -1;
        } else {
          this.childindex = index;
        }
      } else {
        this.childindex = -1;
        if (item.path && item.path != this.$route.fullPath) {
          if (item.meta.props) {
            this.$router.push({
              path: item.path,
              query: {
                props: item.meta.props,
              },
            });
          } else {
            this.$router.push({
              path: item.path,
            });
          }
        }
      }
    },
    //三级菜单跳转
    threepath(item) {
      if (item.path && item.path != this.$route.fullPath) {
        if (item.meta.props) {
          this.$router.push({
            path: item.path,
            query: {
              props: item.meta.props,
            },
          });
        } else {
          this.$router.push({
            path: item.path,
          });
        }
      } else {
        // 如果路径相同且有子路由，跳转到第一个子路由
        if (item.meta.level == 2 && item.children && item.children.length > 0) {
          this.$router.push({
            path: item.children[0].path,
          });
        }
      }
    },
  },
};
</script>
<style lang="scss" scoped>
	.left-title-img{
		display: flex;
		align-items: center;
	}
	.left-title-img img{
		position: relative;
		font-weight: 300;
		left: -100px;
		filter: drop-shadow(#999999 100px 0);
	}
	.left-title-img_active img{
		left: -100px;
		filter: drop-shadow(#006aff 100px 0) !important;
	}
::v-deep .el-icon-arrow-right:before {
  font-size: 14px;
}

.leftmenu {
  width: 160px;
  height: calc(100vh - 68px);
  // background: var(--nav,#1e222b);
  position: absolute;
  top: 68px;
  background: #fff;
}

.morelist {
  width: 100%;
  height: 100%;
  display: inline-block;
  vertical-align: top;
  // padding-top: 60px;
  overflow-y: auto;
  z-index: 999;
  cursor: pointer;
  background: transparent;

  .text {
    color: #333;
    font-size: 14px;
    font-weight: normal;
    line-height: 40px;
    height: auto;
    overflow: hidden;
    user-select: none;
	// margin: 0 10px;
  }

  .titles:hover {
    color: #006aff;
	img{
		filter: drop-shadow(#006aff 100px 0) !important;
	}
	.left-title{
		color: #006aff;
	}
  }
 

  .titles {
    padding: 0 26px;
    display: flex;
    align-items: center;
    // color: var(--navFontDefault,#d8d7d7);
    color: #333;
    position: relative;

    .icons {
      margin-left: 4px;
      font-size: 14px;
      // color: var(--navFontDefault,#d8d7d7);
      color: #333;
      font-weight: 600;
      transition: all 0.3s;
      position: absolute;
      right: 25px;
    }

    .transition {
      transform: rotate(180deg);
    }
	.transition90 {
	  transform: rotate(90deg);
	}
  }

  .flex-list {
    display: flex;
    flex-wrap: wrap;
    // justify-content: space-between;
    // padding: 0 16px;
    box-sizing: border-box;
  }

  .childtext {
    width: 86px;
    font-size: 14px;
    color: #333;
    background: transparent;
    display: flex;
    justify-content: space-between;
    // margin-left: 27px;
	padding-left: 52px;
	width:100%;
    &.navactive {
      .activeBack {
        color: #006aff !important;
        padding: 0 !important;
        justify-content: flex-start !important;
      }
    }
  }

  .childtext:hover {
    color: #006aff;
  }

  .towmenu {
    // font-weight: bold;
    line-height: 40px;

    div {
      text-align: left !important;
      font-weight: normal;
      color: #333;
      // color: var(--navFontDefault,#d8d7d7);
    }
  }

  .towmenu:hover {
    color: #006aff !important;
  }

  .activeBack {
    display: none;
  }

  .navactive {
    height: 40px;
    line-height: 40px;
    position: relative;
    font-weight: bold;
	background-color: rgba(0, 122, 255, .03);
    span {
      display: none;
    }

    .activeBack {
      // padding: 0 15px;
      display: block;
      line-height: 40px;
      border-radius: 8px;
      color: #006aff !important;
      position: relative;
      left: 0;
      // background: rgba(45, 140, 240, 0.1) !important;
      // position: absolute;
      // top: 2px;
      // left: 5px;
      // right: 5px;
      // bottom: 2px;
      // z-index: 0;
    }
  }
}

.hi-svg {
  color: #479cf7 !important;
}
</style>